import {all, takeLatest, put, select} from 'redux-saga/effects'
import axios from "axios";
import {executeAxiosWithExceptionHandling, handleAxiosException} from "./index";
import saveAs from "file-saver";
import {push} from 'react-router-redux';

function* fetchOrderDetail(action) {
    try {
        let response = yield axios.get(`/hotdeals/rest/orders/${action.orderId}`);

        yield put({
            type: 'ORDER_DETAIL_FETCHED',
            orderDetail: response.data
        });

    }catch(exception){
        if (exception && exception.response && exception.response.status === 404) {
            yield put({
                type: 'ORDER_DETAIL_NOT_FOUND'
            })
        }else{
            handleAxiosException(exception);
        }
    }
}

function* downloadClaimedVouchers(action){
    try {
        let state = yield select();
        let response = yield executeAxiosWithExceptionHandling(() =>
            axios.get(`/hotdeals/rest/orders/${action.orderId}/pdf?lang=${state.language.currentLanguage}`, {responseType: 'blob', timeout: 10000})
        );

        saveAs(new Blob([response.data], {type: "application/pdf"}), response.headers.filename);
        yield put({
            type: 'VOUCHERS_DOWNLOADED'
        })
    } catch (exception) {
        if (exception && exception.response && (exception.response.status === 404 || exception.response.status === 423)) {
            yield put({
                type: 'VOUCHERS_NOT_FOUND'
            })
        }else{
            yield put({
                type: 'DOWNLOAD_VOUCHERS_FAILED'
            });
        }
    }
}

function* redirectToOrderDetail(action){
    yield put(push('/order/'.concat(action.orderId)));
}

export default function* rootSaga() {
    yield all([
        takeLatest('FETCH_ORDER_DETAIL', fetchOrderDetail),
        takeLatest('DOWNLOAD_VOUCHERS', downloadClaimedVouchers),
        takeLatest('RETRIEVE_CODE_CLICKED', redirectToOrderDetail)
    ]);
}